<!--
  *用户中心 - 用户信息面板组件，用于个人模块
  *creat by zcg at 2020年3月28日19:01:48
-->
<template>

  <div class="root-container">

    <!--头像区域-->
    <div class="headerContainer">
      <div class="tx-name">
        <van-image round width="41" v-if="userAvatar" class="userAvatar" height="41" :src="userAvatar" />
        <div v-else class="iconfont icon-xueshengguanli userAvatar-icon"></div>

        <div class="userName">
          <div v-if="isLogin">
            <span>{{userName || '暂无名字'}} </span>
          </div>
          <div v-else @click="navToLogin">
            <span>登录</span>
          </div>
        </div>
      </div>
      <div span="6" class="arrowContainer" @click="BTActionUSERSetting" v-if="hasAction">
        <van-icon name="arrow" size="23" />
      </div>
    </div>
    <!-- <van-row>

      <van-col span="6" v-if="userAvatar" class="userAvatar">
        <van-image round width="41" height="41" :src="userAvatar" />
      </van-col>
      <van-col span="6" v-else class="userAvatar-icon">
        <div class="iconfont icon-xueshengguanli"></div>
      </van-col>

      <van-col span="18" class="userName">

        <van-row>

          <van-col span="18" v-if="isLogin">
            <span style="font-size: 2rem;margin-left:  1rem;">{{userName}}</span>
          </van-col>
          <van-col span="18" v-else @click="navToLogin">
            <span style="font-size: 2rem;margin-left:  1rem;">登录</span>
          </van-col>

          <van-col span="6" class="arrowContainer" @click="BTActionUSERSetting" v-if="hasAction">
            <van-icon name="arrow" size="23" />
          </van-col>
        </van-row>

      </van-col>
    </van-row> -->

  </div>

</template>

<script>
export default {
  name: "userInfoPanel",
  props: {
    hasAction: {
      //控制更多按钮显隐
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      userName: "",
      userAvatar: "",
      isLogin: false,
    };
  },
  mounted() {
    let ua = navigator.userAgent.toLowerCase(); // 获取判断用的对象
    if (ua.indexOf("micromessenger") >= 0) {
      this.hasAction = false;
    }
    console.log(this.$store.state.base.userInfo);
    if (
      this.$store.state.base.userInfo != null &&
      sessionStorage.getItem("Token") != null
    ) {
      this.isLogin = true;
      this.userName = this.$store.state.base.userInfo.userInfo.nickName;
      this.userAvatar = this.$store.state.base.userInfo.userInfo.avatarUrl;
    } else {
      this.isLogin = false;
      this.userName = null;
      this.userAvatar = null;
    }
  },
  methods: {
    navToLogin() {
      this.$router.push("/login");
    },
    BTActionUSERSetting() {
      console.log(this.$store.state.base.userInfo);
      if (
        this.$store.state.base.userInfo == null &&
        sessionStorage.getItem("Token") != undefined
      ) {
        this.$router.push("/login");
      } else {
        this.$emit("EMITUserInfoSetting", "user panel actoin");
      }
    },
  },
};
</script>

<style scoped lang="scss">
.root-container {
  width: 100%;
  padding: 1rem 1rem; //上、右、底、左
  background-color: white;
  box-sizing: border-box;
  background: url(/static/img/preson_bg.ab6571a.png) top left no-repeat;
  background-size: 100%;
}

.headerContainer {
  width: 100%;
  background-color: transparent;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  height: 10.2rem;

  .tx-name {
    display: flex;
    justify-content: space-between;
  }
  .userAvatar-icon {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 4rem;
    height: 4rem;
  }
  .userName {
    font-size: 2rem;
    line-height: 4rem;
    margin-left: 1rem;
    font-family: PingFangSC-Regular;
    font-size: 2rem;
    color: #424242;
    letter-spacing: 0;
    text-align: center;
  }
  van-image {
    border-radius: 4rem;
  }
  .arrowContainer {
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: justify;
    height: 4rem;
  }
}
.icon-xueshengguanli {
  font-size: 4rem;
}
</style>



// WEBPACK FOOTER //
// src/components/userInfoPanel.vue